import angular from 'angular';

import MonitoringService from './MonitoringService';
import MonitoringGridFactory from './MonitoringGridFactory';
import MonitoringComponent from './MonitoringComponent';

export default angular
  .module('petroCloud.admin.monitoring', [])
  .service('MonitoringService', MonitoringService)
  .factory('monitoringGridFactory', MonitoringGridFactory)
  .component(MonitoringComponent.name, MonitoringComponent)
  .name;
